import { render, staticRenderFns } from "./themeBook.vue?vue&type=template&id=459835e4&scoped=true&"
import script from "./themeBook.vue?vue&type=script&lang=js&"
export * from "./themeBook.vue?vue&type=script&lang=js&"
import style0 from "./themeBook.vue?vue&type=style&index=0&id=459835e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459835e4",
  null
  
)

export default component.exports